import { FontSpec } from 'chart.js';
import { LabelPosition, AnnotationOptions } from 'chartjs-plugin-annotation';
import { scaleThreshold } from 'd3';

import { formatNumber } from './formatters';
import { getVariable } from './style';

type CreateAnnotationOptions = {
  arrayLength: number;
  firstPosition?: LabelPosition;
  firstY: number;
  fontSize: number;
  labelHorizontalPadding?: number;
  labelBottomPadding: number;
  lastPosition?: LabelPosition;
  lastY: number;
};

export function createFirstLastAnnotations({
  arrayLength,
  firstPosition = 'start',
  firstY,
  fontSize,
  labelBottomPadding,
  labelHorizontalPadding = 0,
  lastPosition = 'end',
  lastY,
}: CreateAnnotationOptions) {
  const extremeValues =
    arrayLength > 1
      ? [
          {
            position: firstPosition,
            x: 0,
            y: firstY,
            label: firstY,
          },
          {
            position: lastPosition,
            x: arrayLength - 1,
            y: lastY,
            label: lastY,
          },
        ]
      : [];

  return extremeValues.reduce((acc, { position, x, y, label }) => {
    acc[x] = {
      content: [formatNumber(label, 0)],
      color: getVariable('--green-30'),
      font: {
        family: '"DM Sans", sans-serif',
        size: fontSize,
      } as FontSpec,
      padding: {
        top: 0,
        bottom: 0,
        left: labelHorizontalPadding,
        right: labelHorizontalPadding,
      },
      position: {
        x: position,
      },
      type: 'label',
      xValue: x,
      yValue: y,
      yAdjust: -(fontSize / 2 + labelBottomPadding),
    };
    return acc;
  }, {} as Record<string, Partial<AnnotationOptions>>);
}

export function getFontSizeForWindow() {
  const scale = scaleThreshold<number, number>()
    .domain([1600, 1900, 2560])
    .range([8, 10, 12, 19]);
  return scale(window.innerWidth);
}
